import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBell2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C8.10602 2 4.89608 5.05346 4.70162 8.94258L4.51173 12.7405L3 15.7639V18H7.10002C7.56329 20.2822 9.58104 22 12 22C14.419 22 16.4367 20.2822 16.9 18H21V15.7639L19.4883 12.7405L19.2984 8.94258C19.1039 5.05346 15.894 2 12 2ZM12 20C10.6938 20 9.58254 19.1652 9.17071 18H14.8293C14.4175 19.1652 13.3062 20 12 20Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBell2;
